<template>
  <div class="yunClass">
    <div class="yunClass-ban">
      <div class="bantxt">
        <div class="absout-bantext">踏踏实实磨产品，真心诚意做服务</div>
      </div>
    </div>
    <txt-nav :navList="txtList" :label="title" @goPage="goPage"></txt-nav>
    <!-- 下部内容 -->
    <div class="yunClass-con" v-if="noCurriculum">
      <div class="yunClass-right">
        <div class="display-title">
          <div class="yunClass-back" @click="closeDetail()">
            <div class="yunClass-close"></div>
          </div>
        </div>
      </div>
      <div class="notice-detail">
        <div
          class="detail-title"
          style="word-wrap: break-word;word-break: normal;"
        >
          {{ dynamic.dynamicTitle }}
        </div>
        <div class="detail-time">
          {{ dynamic.publishTime | formatDate("yyyy-MM-dd hh:mm:ss") }} 发表于
          {{ toGroupName }}
        </div>
        <!-- 长文显示及短文除去视频及图片 -->
        <div
          class="detail-con"
          style="word-wrap: break-word;word-break: normal;"
          v-html="dynamic.dynamicContent"
        ></div>
      </div>
    </div>
    <div class="yunClass-con" v-else>
      <img class="noCurriculum" src="@/assets/noCurriculum.png" alt="" />
      <div class="noCurriculum-txt">暂无内容</div>
    </div>
  </div>
</template>

<script >
import txtNav from "@/components/txt-nav.vue";
import { getCloudClassForShare, classCount } from "@/api";
export default {
  components: {
    txtNav
  },
  data() {
    return {
      docText: "",
      detailTitle: "",
      dynamic: {},
      toGroupName: "",
      txtList: [
        { type: 0, label: "服务体系" },
        { type: 1, label: "产品报价" },
        // { type: 2, label: "价格计算器" },
        { type: 3, label: "云课堂" },
        { type: 4, label: "培训课表" },
        { type: 5, label: "示范仓" }
      ],
      noCurriculum: true,
      maskPramas: {}
    };
  },
  // props: {
  //   maskPramas: {
  //     type: Object,
  //     default: {}
  //   }
  // },
  methods: {
    goPage(item) {
      this.title = item.label;
      switch (item.type) {
        case 0:
          window.location.href = "/pages/service.html";
          // window.location.href = "/static/pages/service.html";
          break;
        case 1:
          window.location.href = "/pages/sell.html";
          // window.location.href = "/static/pages/sell.html";
          break;
        case 2:
          window.location.href = "/calculator";
          break;
        case 3:
          window.location.href = "/yunClass";
          break;
        case 4:
          window.location.href = "/pages/curriculum.html";
          // window.location.href = "/static/pages/curriculum.html";
          break;
        case 5:
          window.location.href = "/pages/showhow.html";
          // window.location.href = "/static/pages/showhow.html";
          break;
      }
    },
    closeDetail() {
      this.$router.replace("/yunClass");
    },
    getCloudClassForShare(yunClassId) {
      let params = {
        params: {
          dynamicId: yunClassId
        }
      };
      getCloudClassForShare(params)
        .then(res => {
          if (res.code === 200) {
            let data = res.result.data;
            if (data) {
              this.dynamic = data.dynamic;
              this.toGroupName = data.toGroupName;
              window.scrollTo(0, 0);
            } else {
              this.noCurriculum = false;
            }
          }
        })
        .catch(err => console.log(err));
    }
  },
  created() {
    if (JSON.stringify(this.$route.query) == "{}") {
      this.noCurriculum = false;
    } else {
            //跳转后页面获取参数对象
      this.maskPramas = this.$route.query;
      this.getCloudClassForShare(this.maskPramas.dynamicId); // 动态的id
      // this.detailTitle = this.maskPramas.title;
      classCount({ id: this.maskPramas.id }); // 云课堂列表记录的id
    }
  }
};
</script>

<style lang="less" scope>
.yunClass-ban {
  width: 100%;
  height: 198px;
  position: relative;
  padding-top: 172px;
  background-image: url("../assets/serviceBanner.jpg");
  // background-image: url("../assets/yunClass-ban.jpg");
  background-size: 100% 100%;
  .bantxt {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    .absout-bantext {
      font-size: 34px;
      font-weight: 200;
      line-height: 80px;
      color: rgba(255, 255, 255, 1);
    }
  }
}

.yunClass-right {
  width: 1200px;
  margin: 0 auto;
}
.display-title {
  margin-bottom: 20px;
  color: #666666;
  font-size: 22px;
  text-align: center;
}
.yunClass-back {
  float: right;
  margin-top: 18px;
  margin-right: 20px;
  .yunClass-close {
    position: relative;
    width: 30px;
    height: 20px;
  }

  .yunClass-close::before,
  .yunClass-close::after {
    position: absolute;
    content: " ";
    background-color: #999;
    left: 20px;
    width: 2px;
    height: 25px;
  }

  .yunClass-close::before {
    transform: rotate(45deg);
  }

  .yunClass-close::after {
    transform: rotate(-45deg);
  }

  .yunClass-close:hover:before,
  .yunClass-close:hover:after {
    background-color: #5485e8;
  }
}

.notice-detail {
  width: 1160px;
  margin: 0 auto;
  padding: 0 20px 20px 20px;
  background-color: #fff;
}
.detail-title {
  font-size: 22px;
  color: #333;
  text-align: center;
  padding: 24px;
  margin-bottom: 10px;
}
.detail-time {
  // background-color: #f6f6f6;
  color: #666;
  font-size: 12px;
  padding: 10px 0;
  text-align: center;
}
.detail-con {
  padding: 20px 0;
  text-align: left;
  font-size: 16px;
  line-height: 28px;
}
.detail-comment {
  text-align: left;
  margin-bottom: 20px;
  border-top: 1px solid #e1e1e1;
  .detail-item {
    display: flex;
    .detail-avtor {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 15px;
    }
    .detail-right {
      .avtor-comment {
        line-height: 18px;
      }
      .avtor-title {
        font-size: 14px;
        color: #4a70bc;
        padding-bottom: 10px;
      }
      .avtor-time {
        font-size: 12px;
        color: #9ea4a7;
        padding: 12px 0;
      }
    }
  }
}

        .noCurriculum {
            width: 362px;
            height: auto;
            margin: auto;
            margin-top: 60px;
        }

        .noCurriculum-txt {
            font-size: 18px;
            text-align: center;
            color: #9e9e9f;
            line-height: 70px;
        }
</style>


// WEBPACK FOOTER //
// src/views/yunClass-detail.vue